import { apiClient } from "@/lib/api-client";
import { FeedbackRequest, FeedbackResponse } from "@/types/feedback";

export class FeedbackService {
  /**
   * Submit feedback or support request
   */
  async submitFeedback(request: FeedbackRequest): Promise<FeedbackResponse> {
    return apiClient.post("/feedback/", request);
  }
}

export const feedbackService = new FeedbackService();
